angular.module('clientDashboardApp').directive('closableTag',() => {
  return {
    restrict: 'AE',
    template: `<span class="badge badge-pill closable {{tagStyle}} {{isClosable() ? '' : 'closable-disabled'}}" ng-class="">{{name}}<span ng-if="isClosable()" ng-click="callback({param1:param1,param2:param2})" class="far fa-times btn-close ml-1 cursor-pointer"></span></span>`,
    scope: {
      name : '=',
      param1 : '=',
      param2 : '=',
      callback : '&',
      tagStyle : '@',
      tagSize : '@',
      closable: '='
    },
    controller: ($scope) => {
      $scope.isClosable = () => (angular.isDefined($scope.closable) ? $scope.closable : true);
    }
  }
})
